import defaultPhoneNumbers from './phone-numbers'

const phoneMappingConfig: PhoneMapping = {
  ...defaultPhoneNumbers,
  default: {
    number: '8005491664',
    pretty: '(800) 549-1664'
  }
}

export default phoneMappingConfig
